class EcBenefitsBarSlider {
  constructor(sectionId, options = {}) {
    this.sectionId = sectionId;
    this.autoplayEnabled = options.autoplayEnabled !== undefined ? options.autoplayEnabled : true;
    this.autoplayInterval = options.autoplayInterval || 4000;
    this.resumeDelay = options.resumeDelay || 5000;
    this.mobileBreakpoint = 749;

    this.slider = document.getElementById(`ec-benefits-bar-slider-${sectionId}`);
    this.dotsContainer = document.getElementById(`ec-benefits-bar-dots-${sectionId}`);

    if (!this.slider || !this.dotsContainer) return;

    this.dots = this.dotsContainer.querySelectorAll('.ec-benefits-bar__dot');
    this.items = this.slider.querySelectorAll('.ec-benefits-bar__item');

    if (this.dots.length === 0 || this.items.length === 0) return;

    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.resumeTimer = null;
    this.isUserInteracting = false;
    this.scrollTimeout = null;

    this.init();
  }

  isMobile() {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  getItemWidth() {
    return this.items[0].offsetWidth + 16;
  }

  updateDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  goToSlide(index, smooth = true) {
    this.currentIndex = index;
    const itemWidth = this.getItemWidth();
    this.slider.scrollTo({
      left: index * itemWidth,
      behavior: smooth ? 'smooth' : 'auto'
    });
    this.updateDots(index);
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.items.length;
    this.goToSlide(nextIndex);
  }

  startAutoplay() {
    if (!this.isMobile() || !this.autoplayEnabled) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.nextSlide(), this.autoplayInterval);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  scheduleResume() {
    if (!this.autoplayEnabled) return;
    clearTimeout(this.resumeTimer);
    this.resumeTimer = setTimeout(() => {
      this.isUserInteracting = false;
      this.startAutoplay();
    }, this.resumeDelay);
  }

  handleUserInteraction() {
    this.isUserInteracting = true;
    this.stopAutoplay();
    this.scheduleResume();
  }

  onScroll() {
    const scrollLeft = this.slider.scrollLeft;
    const itemWidth = this.getItemWidth();
    const newIndex = Math.round(scrollLeft / itemWidth);

    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex;
      this.updateDots(this.currentIndex);
    }
  }

  init() {
    // Click on dots
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.handleUserInteraction();
        const index = parseInt(dot.dataset.index, 10);
        this.goToSlide(index);
      });
    });

    // Touch events
    this.slider.addEventListener('touchstart', () => this.handleUserInteraction(), { passive: true });

    // Scroll events
    this.slider.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => this.onScroll(), 50);
    }, { passive: true });

    // Handle resize
    window.addEventListener('resize', () => {
      if (this.isMobile()) {
        if (this.autoplayEnabled && !this.autoplayTimer && !this.isUserInteracting) {
          this.startAutoplay();
        }
      } else {
        this.stopAutoplay();
      }
    });

    // Pause when not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else if (this.isMobile() && this.autoplayEnabled && !this.isUserInteracting) {
        this.startAutoplay();
      }
    });

    // Start autoplay if mobile and enabled
    if (this.isMobile() && this.autoplayEnabled) {
      this.startAutoplay();
    }
  }
}

